import { render, staticRenderFns } from "./widgetWrapper.vue?vue&type=template&id=28ab317b&scoped=true"
import script from "./widgetWrapper.vue?vue&type=script&lang=js"
export * from "./widgetWrapper.vue?vue&type=script&lang=js"
import style0 from "./widgetWrapper.vue?vue&type=style&index=0&id=28ab317b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab317b",
  null
  
)

export default component.exports